export const handleCognitoResponse = async (): Promise<boolean> => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get("code");

  if (!code) {
    return false;
  }

  try {
    const response = await fetch("https://eu-central-1kyk5sovel.auth.eu-central-1.amazoncognito.com/oauth2/token", {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        grant_type: "authorization_code",
        client_id: "2qo94mdqghvsj98ci1g2mr35ih",
        redirect_uri: `${window.location.origin}`,
        code: code,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch token: ${response.statusText}`);
    }

    const data = await response.json();
    sessionStorage.setItem("idToken", data.id_token);
    sessionStorage.setItem("accessToken", data.access_token);
    sessionStorage.setItem("refreshToken", data.refresh_token);

    return true;
  } catch (error) {
    console.error("Error handling Cognito response:", error);
    return false;
  }
};
